// externals
import { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';

// types
import { CDL_V3_EVENT } from '@makemydeal/dr-shared-types';

/**
 * Hook for the CDL event.
 * Returns a ref callback; dispatches once when the attached element first enters the viewport.
 */
export const useWarrantyCoverageCdlEvent = (): ((node: HTMLDivElement | null) => void) => {
    const dispatch = useDispatch();
    const hasDispatchedRef = useRef(false);
    const observerRef = useRef<IntersectionObserver | null>(null);

    return useCallback(
        (node: HTMLDivElement | null) => {
            if (observerRef.current) {
                observerRef.current.disconnect();
                observerRef.current = null;
            }

            if (!node || hasDispatchedRef.current || typeof IntersectionObserver === 'undefined') return;

            const observer = new IntersectionObserver(([entry]) => {
                if (entry.isIntersecting && !hasDispatchedRef.current) {
                    hasDispatchedRef.current = true;
                    observer.disconnect();
                    dispatch({
                        type: CDL_V3_EVENT,
                        payload: {
                            action: 'View',
                            element: 'Warranty Coverage Workflow Display',
                            location: ['VPP', 'Workflow Section Display'],
                            intention: 'Warranty Coverage section displayed to the user',
                            tagIndex: 'dc-sci-069'
                        }
                    });
                }
            });

            observerRef.current = observer;
            observer.observe(node);
        },
        [dispatch]
    );
};
